export default __webpack_public_path__ + "static/media/warning--turn-right--g3.df561544.png";